import { Injectable } from '@angular/core';
import * as _ from 'lodash';
@Injectable({
    providedIn: 'root'
})


export class LwCheckbox{
    // constructor method
    renderElement = function(containerId, options) {

        var mainContainer = document.getElementById(containerId);
        console.log("\n----------------")
        console.log("options name::::::", options.name)
        console.log("options isHide::::::", options.isHide)
        console.log("----------------\n")
        if (((_.get(options, 'isHide'))) != true) {
            var uniqueKey = options.keyToUpdate;
            var elementContainer = document.createElement("div");
            elementContainer.setAttribute("class", "padding-top-20 padding-bottom-20");
            if (uniqueKey && containerId) {
                elementContainer.setAttribute("uniqueKeyContainer", uniqueKey + "__" + containerId)
            }
            var classToSet = "col col-lg-12 col-md-12 col-sm-12 col-xs-12";
            if (options["showLabel"]) {
                var labelContainer = document.createElement("div");
                labelContainer.setAttribute("class", "col col-lg-4 col-md-4 col-sm-4 col-xs-12");
    
                var inputLabel = document.createElement("label");
                var labelClass = (options["isRequired"]) ? "lw-form-renderer--required" : "";
                inputLabel.setAttribute("class", labelClass + " lw-form-renderer__label lw-form-renderer__label-font--style--color col-form-label");
                inputLabel.innerHTML = options["name"];
                if(options.tooltipText) // check if the tooltips is required for this very row
                {
                    var textForToolTip  = 'title='+'"'+options.tooltipText+'"' ;
                    var spanForToolTip = document.createElement("span");
                    spanForToolTip.innerHTML = "<div style='display: inline;'><a style='cursor: pointer;'"+textForToolTip+"><img src='https://static1.litmusworld.com/logos/info_1557394045031.png'></a></div>"
                    inputLabel.appendChild(spanForToolTip);
    
                }
    
                labelContainer.appendChild(inputLabel);
                elementContainer.appendChild(labelContainer);
                classToSet = "col col-lg-8 col-md-8 col-sm-8 col-xs-12";
            }
            var checkboxContainer = document.createElement("div");
            checkboxContainer.setAttribute("class", classToSet);
            // <label class="lw-table-renderer__checkbox-container" ng-style="{'margin-bottom':headerValue.cell_margin_bottom}">
            //                    <input type='checkbox' id="rule_is_disabled_{{tableRendererVm.callee}}_{{index}}" ng-click="tableRendererVm.enable('rule_is_disabled_', tableRendererVm.callee, index, value)" ng-checked="value.is_enabled">
            //                    <span class="checkmark" ng-style="{'right':headerValue.right}"></span>
            //                </label>
    
            _.each(options["checkboxOptions"], function(detail, index) {
                // if ((!(Utils.getProp(detail, 'isHide'))) == true) {
    
                var checkboxLabelContainer = document.createElement("div");
                var classForCheckboxLabelContainer = (index == 0) ? "display-inline-block" : "margin-left-30 display-inline-block";
                checkboxLabelContainer.setAttribute("class", classForCheckboxLabelContainer);
                var label = document.createElement("label");
                label.setAttribute("class", 'lw-table-renderer__checkbox-container');
                var checkbox = document.createElement("input");
                checkbox.setAttribute("type", "checkbox");
                checkbox.setAttribute("for", detail["id"]);
                var span = document.createElement("span");
                span.setAttribute("class", "checkmark")
    
                // Prepopulate value if available
                if (options["value"]) {
                    // If options.value is a boolean value it means no sub options
                    if (typeof options["value"] == "boolean") {
                        checkbox.checked = options["value"] || false;
                    } else if (detail["id"] in options["value"]) {
                        checkbox.checked = options["value"][detail["id"]] || false;
                    }
                }
    
                // Add Event to the checkbox and update the value 
                checkbox.addEventListener('click', function(event) {
                    if (!("value" in options)) {
                        options["value"] = {};
                    }
                    if (options["checkboxOptions"].length > 1) {
                        // in case more than a options
                        options["value"][detail["id"]] = _.get(event, "target.checked") || false;
                    } else {
                        options["value"] = _.get(event, "target.checked") || false;
                        if (options.eventToUpdateValue && options.pathToUpdate) {
                            // this.fire(options.eventToUpdateValue, { "value": options["value"], "pathToUpdate": options.pathToUpdate });
                        } else if (options.eventToUpdateValue && options.pathToUpdate) {
                            // this.fire(options.eventToUpdateValue, { "value": false, "pathToUpdate": options.pathToUpdate });
                        }
                        // options["value"][detail["id"]] = Utils.getProp(event, "target.checked") || false;
                    }
                });
                label.appendChild(checkbox)
                label.appendChild(span)
    
                checkboxLabelContainer.appendChild(label);
    
                var checkboxLabel = document.createElement("label");
                checkboxLabel.setAttribute("class", "padding-left-10 lw-form-renderer__label lw-form-renderer__checkbox-label-font--style--color  lw-checkbox__lable--margin");
                checkboxLabel.innerHTML = detail["name"] || "";
    
                checkboxLabelContainer.appendChild(checkboxLabel);
    
    
                checkboxContainer.appendChild(checkboxLabelContainer);
                // }
            })
    
            elementContainer.appendChild(checkboxContainer);
    
            if (mainContainer)
                mainContainer.appendChild(elementContainer);
        }
    
    }
}